module.exports = __webpack_public_path__ + "img/chevron_down.537b41b1.svg";